import { create } from 'zustand';
import { authAPI } from '../api';

const useAuthStore = create((set, get) => ({
  user: null,
  token: localStorage.getItem('bf_token'),
  loading: true,

  login: async (email, password) => {
    const { data } = await authAPI.login({ email, password });
    localStorage.setItem('bf_token', data.token);
    set({ token: data.token, user: data.user, loading: false });
    return data.user;
  },

  register: async (form) => {
    const { data } = await authAPI.register(form);
    localStorage.setItem('bf_token', data.token);
    set({ token: data.token, user: data.user, loading: false });
    return data.user;
  },

  logout: () => {
    localStorage.removeItem('bf_token');
    set({ user: null, token: null, loading: false });
  },

  fetchMe: async () => {
    try {
      const { data } = await authAPI.me();
      set({ user: data, loading: false });
    } catch {
      set({ user: null, loading: false });
    }
  },

  isPremium:       () => get().user?.is_premium === true,
  isTrialActive:   () => get().user?.is_trial_active === true,
  hasAccess:       () => get().user?.has_access === true,
  trialDaysLeft:   () => get().user?.trial_days_left ?? 0,
  isAdmin:         () => get().user?.role === 'admin',
  isViaFamilyPlan: () => get().user?.via_family_plan === true,
  isFamilyReadOnly:() => get().user?.family_read_only === true,
}));

export default useAuthStore;